import axios from '@/axios'
import vuecookie from "vue-cookies";
import { backendUrl } from '@/helpers/backendUrl.js'

const state = {
    postingDailyTallies: [],
};

const getters = {
    getPostingDailyTallies: (state) => state.postingDailyTallies,
};

const mutations = {
    setPostingDailyTallies: (state, postingDailyTallies) => (state.postingDailyTallies = postingDailyTallies),
};

const actions = {
    async loadPostingDailyTallies(context, data) {
        await axios().get(`/getPostingDailyTallies`, {
            params: {
                date_from: data.date_from,
            }
        }).then(response => {
            context.commit('setPostingDailyTallies', response.data.postingDailyTallies)
            context.dispatch('handleResponse', response)
        })
    },
    async updateDocketsItem(context, data) {
        await axios().post(`/updateDocketsItem`, {
            item: data.item
        }).then(response => {
            context.dispatch('handleResponse', response)
        })
    },
    async preparePostingDailyTalliesTableCsv( context, data ) {
        return await axios().post(`${backendUrl()}/preparePostingDailyTalliesTableCsv`, {
            date_from: data.date_from,
        }, {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            if (response.data.status && response.data.status === 'error') {
                context.dispatch('handleResponse', response)
            }

            return response.data
        })
    },
    async preparePostingDailyTalliesLineListingCsv( context, data ) {
        return await axios().post(`${backendUrl()}/preparePostingDailyTalliesLineListingCsv`, {
            date_from: data.date_from,
            class: data.class
        }, {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
            .then(response => {
                if (response.data.status && response.data.status === 'error') {
                    context.dispatch('handleResponse', response)
                }

                return response.data
            })
    },
};

export default {
    state,
    getters,
    actions,
    mutations
}
